var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticStyle:{"max-width":"400px","margin-top":"100px"},attrs:{"cols":"10"}},[_c('SetPassword')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }